import { render } from "./AboutMeComponent.vue?vue&type=template&id=861cae3a"
const script = {}

import "./AboutMeComponent.vue?vue&type=style&index=0&id=861cae3a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__